import PageHeading from 'components/shared/PageHeading'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import logo from 'assets/logoIcon.png'
import process1 from 'assets/process1.png'
import process2 from 'assets/process2.png'
import process3 from 'assets/process3.png'
import ProcessCard from 'components/ProcessCards'

const processdata = [
  {
    image: process1,
    title: "Concept and Planning",
    list: ["Defining Clarity", "Resource Planning", "Conceptualization"],
    para: (
      <p>
        We work closely with you to define the vision of your project. By conceptualizing innovative ideas and meticulously planning resources, we ensure every detail aligns perfectly with your goals from day one.
      </p>
    ),
  },
  {
    image: process2,
    title: "Coordination",
    list: ["Timeline Management", "Quality Control", "Client Feedback"],
    para: (
      <p>
        We manage timelines, conduct rigorous quality control, and quickly iterate based on your feedback. Our collaborative approach ensures that your vision is realized smoothly and efficiently to its fullest potential.
      </p>
    ),
  },
  {
    image: process3,
    title: "Installation",
    list: ["Rigorous Testing", "Seamless Delivery"],
    para: (
      <p>
        Our expert team handles the entire installation. We rigorously test every component to ensure a seamless delivery. We take pride in providing a finished product that exceeds expectations and creates a lasting impact.
      </p>
    ),
  },
];

const Process = () => {
  return (
    <Container className="py-5 mt-md-5">
      <div className="mb-3 mt-md-5 d-md-block d-none">
        <PageHeading image={logo} text={"PROCESSES"} />
      </div>
      <div className="mb-3 d-md-none">
        <PageHeading center={true} image={logo} text={"PROCESSES"} />
      </div>

      <Row className="align-items-center text-center text-md-start">
        <Col lg={6} className="mb-4 mb-lg-0">
          <h2 className='mb-0'>
            <strong>Living Wall Processes:</strong>
          </h2>
          <h2>
            <i>Concept, Coordination, Installation</i>
          </h2>
          <p>
            Learn about Living Wall’s turn-key services, from initial concept
            <br className="d-lg-block d-none" />to final installation.
          </p>
        </Col>

        <Col lg={6} className="mb-4 mb-lg-0">
          <p>
            <strong>At Living Wall,</strong> we offer end-to-end services for your digital space transformation. We ensure seamless execution from start to finish, structured into three key phases:
          </p>
        </Col>
      </Row>

      <Row className='py-5'>
        {processdata?.map((p, i) => (
          <Col key={i} xl={4} lg={6} className="mb-4">
            <ProcessCard image={p.image} list={p.list} title={p.title} para={p.para} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Process;
